module.exports = __webpack_public_path__ + "static/media/fruit.4800656f.svg";